// extracted by mini-css-extract-plugin
module.exports = {"imageAvatars":"Lw_GYHoY","tasksAImageAvatar":"__3MUHssuz","tasksACreateBtn":"cshfLOTN"};